import { i18n } from '../../i18n/i18n.js'

export class Disclaimer {
  constructor() {
    this.element = null
  }

  render() {
    this.element = document.createElement('div')
    this.element.className = 'disclaimer'
    this.element.innerHTML = `
      <p class="disclaimer-text">${i18n.t('disclaimer.text')}</p>
    `
    return this.element
  }

  update() {
    if (this.element) {
      const textEl = this.element.querySelector('.disclaimer-text')
      if (textEl) {
        textEl.textContent = i18n.t('disclaimer.text')
      }
    }
  }
}
